var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mu-dialog',{attrs:{"open":_vm.common.dialogalert.isopen,"title":"提示"}},[_vm._v("\r\n    "+_vm._s(_vm.common.dialogalert.msg)+"\r\n    "),_c('mu-flat-button',{attrs:{"slot":"actions","label":"确定","primary":""},on:{"click":_vm.close},slot:"actions"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.5.0@vue-loader/lib/template-compiler?{"id":"data-v-40f4a7b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogAlert.vue
// module id = null
// module chunks = 